import React, { useState, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from 'dayjs';
import moment from "moment";
import axios from "axios";
import { APIURL } from "../../../config";

const shortcutsItems = [
    {
        label: 'This Week',
        getValue: () => {
            const today = dayjs();
            return [today.startOf('week'), today.endOf('week')];
        },
    },
    {
        label: 'Last Week',
        getValue: () => {
            const today = dayjs();
            const prevWeek = today.subtract(7, 'day');
            return [prevWeek.startOf('week'), prevWeek.endOf('week')];
        },
    },
    {
        label: 'Last 7 Days',
        getValue: () => {
            const today = dayjs();
            return [today.subtract(7, 'day'), today];
        },
    },
    {
        label: 'Current Month',
        getValue: () => {
            const today = dayjs();
            return [today.startOf('month'), today.endOf('month')];
        },
    },
    {
        label: 'Last Month',
        getValue: () => {
            const today = dayjs();
            const lastMonth = today.subtract(1, 'month');
            return [lastMonth.startOf('month'), lastMonth.endOf('month')];
        },
    },
    { label: 'Reset', getValue: () => [null, null] },
];

export default function EVVDashboard(props) {
    const [fromDate, setFromDate] = useState(() => dayjs().startOf('week').toDate());
    const [toDate, setToDate] = useState(() => dayjs().endOf('week').toDate());
    const [iframeUrl, setiframeUrl] = useState('');
    const [isIframeLoading, setIsIframeLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, [fromDate, toDate]);

    const fetchData = async () => {
        axios
            .get(APIURL + "/metabase/evvDashboard", {
                params: {
                    companyID: props.user.comp_id,
                    companyName: props.user.company_name,
                    fromDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : null,
                    toDate: toDate ? moment(toDate).format('YYYY-MM-DD') : null,
                },
            })
            .then((response) => {
                setiframeUrl(response.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleIframeLoad = () => {
        setIsIframeLoading(false);
    };

    return (
        <div style={{ width: "100%" }}>
            <div style={{ display: 'flex', marginLeft: 10, marginRight: 10, marginTop: 10, width: '100%' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateRangePicker
                        label='Date Range'
                        defaultValue={shortcutsItems[0].getValue()}
                        onChange={(newValue) => {
                            setFromDate(newValue[0] ? new Date(newValue[0]) : null);
                            setToDate(newValue[1] ? new Date(newValue[1]) : null);
                        }}
                        slotProps={{
                            shortcuts: {
                                items: shortcutsItems,
                            },
                            textField: { size: 'small', style: { width: 275 } },
                        }}
                    />
                </LocalizationProvider>
            </div>
            <div style={{ marginLeft: 10, marginRight: 10, width: '100%' }}>
                <iframe
                    src={iframeUrl}
                    style={{ width: '100%', height: '75vh', border: 'none', backgroundColor: 'transparent', colorScheme: 'light' }}
                    allowTransparency
                    onLoad={handleIframeLoad}
                />
            </div>
        </div>
    );
};